"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageBackedAsyncStore = void 0;
/*
 * Removing stale keys is faciliating by storing the entire configuration into a single
 * key in local storage. This is done by serializing the entire configuration object
 * into a string and then storing it to a single key. When retrieving the configuration,
 * we first check if the configuration exists in local storage. If it does, we deserialize
 * the configuration from the string and return it. If the configuration does not exist,
 * we return null.
 */
class LocalStorageBackedAsyncStore {
    constructor(localStorage) {
        this.localStorage = localStorage;
        this.localStorageKey = 'eppo-configuration';
        this._isInitialized = false;
    }
    isInitialized() {
        return this._isInitialized;
    }
    isExpired() {
        return Promise.resolve(true);
    }
    getEntries() {
        const configuration = this.localStorage.getItem(this.localStorageKey);
        if (!configuration) {
            return Promise.resolve({});
        }
        return Promise.resolve(JSON.parse(configuration));
    }
    setEntries(entries) {
        this.localStorage.setItem(this.localStorageKey, JSON.stringify(entries));
        this._isInitialized = true;
        return Promise.resolve();
    }
}
exports.LocalStorageBackedAsyncStore = LocalStorageBackedAsyncStore;
//# sourceMappingURL=local-storage.js.map